export default "__VITE_ASSET__CIoaUvTi__"